import script from "./SellerSettingsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerSettingsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerSettingsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__